import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import Image from "react-bootstrap/Image";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import StatusModal from './StatusModal';

// import { SRLWrapper } from "simple-react-lightbox";
//import isEmpty from "../../../../../store/validation/is-Empty";
import { SuggestionDropDownModelPopup } from "../../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import {
  update_super_admin_open_issues,
  superadmin_vendor_Single_open_issue,
} from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
const statusTypes = [
  { name: "New", status: 0 },
  { name: "In-Progress", status: 1 },
  { name: "Awaiting Feedback", status: 2 },
  { name: "On Hold", status: 3 },
  { name: "Re-Opened", status: 4 },
  { name: "Resolved", status: 5 },
  { name: "Closed", status: 6 },
  { name: "Archive", status: 7 },
  { name: "Pending", status: 8 },
  { name: "Communicated", status: 9 },
  { name: "Uploaded", status: 10 },
];

export const AdminViewIssues = (
  props
  // { props.issuesData, restaurantData, emailData, contactDetails, category }
) => {
  const options = {
    settings: {
      autoplaySpeed: 3000,
      disableKeyboardControls: false,
      disablePanzoom: false,
      disableWheelControls: false,
      hideControlsAfter: 3000,
      lightboxTransitionSpeed: 0.6,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: 0.6,
      slideTransitionTimingFunction: "linear",
    },
    buttons: {
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: false,
      showPrevButton: false,
      showThumbnailsButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
    progressBar: {
      showProgressBar: false,
    },
  };

  const data =
    props.issuesData &&
    props.issuesData.restaurant_id &&
    props.issuesData.restaurant_id.contact_detail;

  const dispatch = useDispatch();

  const [currentStatus, setCurrentStatus] = useState(0);

  const onConfirmClose = () => {
    setModalStatus(false);
  };

  useEffect(() => {
    setCurrentStatus(props.issuesData && props.issuesData.status);
  }, [props.issuesData && props.issuesData.status]);

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Pending";
    } else if (status === 9) {
      return "Communicated";
    } else if (status === 10) {
      return "Uploaded";
    }
  };

  const onSubmit = () => {
    const token = props.token;
    let issueId = props.issuesData && props.issuesData._id;
    const formData = {};
    formData.status = currentStatus;
    dispatch(
      update_super_admin_open_issues(
        formData,
        token,
        issueId,
        onSuccess(token, issueId, onSuccess)
      )
    );
  };

  const onSuccess = (token, issueId) => (e) => {
    dispatch(superadmin_vendor_Single_open_issue(issueId, token));
    onConfirmClose();
  };

  const [modalStatus, setModalStatus] = useState(false);

  const onCloseModal = () => {
    setModalStatus(false);
  };

  const onChangeTempStatus = (status) => {
    setCurrentStatus(status);
  };

  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_left">
        <div className="row">
          <div className="col-2">
            <h5 className="f14-500 text-gray mb-3">Issue ID</h5>
            <h5 className="f12-400">
              {props?.issuesData?.issue_id || ""}
            </h5>
          </div>
          <div className="col-2">
            <h5 className="f14-500 text-gray mb-3">Category</h5>
            <h5 className="f12-400">
              {props?.issuesData?.category?.title || ""}
            </h5>
          </div>
          <div className="col-2">
            <h5 className="f14-500 text-gray mb-3">Type</h5>
            <h5 className="f12-400">
              {props?.issuesData?.type || ""}
            </h5>
          </div>
          <div className="col-3">
            <h5 className="f14-500 text-gray mb-3">Created By</h5>
            <h5 className="f12-400">
              {props?.issuesData?.createdBy?.name || ""}
            </h5>
            <h5 className="f10-400">
              {props?.issuesData?.createdBy?.role || ""}
            </h5>
          </div>
          <div className="col-3">
            <h5 className="f14-500 text-gray mb-3">Status</h5>
            <div className="mb-2 text-white f9-700 bg-yellow enlblSelect" onClick={() =>
              setModalStatus(true)
            }>
              {calcStatus(props.issuesData && props.issuesData.status)}
              <i
                className="ml-2 fa fa-angle-down"
                aria-hidden="true"

              ></i>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-6">
            <h5 className="f14-500 text-gray mb-3">Issue Date/Time</h5>
            <h5 className="f12-400">
              {moment(props.issuesData && props.issuesData.createdAt).format(
                "Do MMMM YYYY, hh:mm A"
              )}
            </h5>
          </div>
          <div className="col-6">
            <h5 className="f14-500 text-gray mb-3">Issue Title</h5>
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.issue_title}
            </h5>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <h5 className="f14-500 text-gray mb-3">Description</h5>
          </div>
          <div className="col-8">
            <h5 className="f12-400">
              {props.issuesData && props.issuesData.comment}
            </h5>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <h5 className="f12-500 text-gray mb-3">Photos</h5>
          </div>
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center">
              {props.issuesData &&
                props.issuesData.attachment &&
                props.issuesData.attachment.map((photos, index) => {
                  return (
                    <React.Fragment key={index}>
                      <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <div className="enIMG33 rounded-circle mr-2">
                            <Image
                              fluid
                              src={photos}
                              alt="Icon"
                              title="Issues Photo"
                            />
                          </div>
                        </SRLWrapper>
                      </SimpleReactLightbox>
                      {/* <SimpleReactLightbox>
                        <SRLWrapper options={options}>
                          <Image
                            fluid
                            alt="Restaurant Photo"
                            title="Restaurant Photo"
                            className="w-25 rounded-circle"
                            src={photos}
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox> */}
                    </React.Fragment>
                  );
                })}
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-4 text-center">
            <h5 className="f14-500 mb-2">Restaurant Name</h5>
            <SimpleReactLightbox>
              <SRLWrapper options={options}>
                <Image
                  fluid
                  alt="Restaurant Photo"
                  title="Restaurant Photo"
                  className="w-25 rounded-circle"
                  src={
                    props.issuesData &&
                    props.issuesData.restaurant_id &&
                    props.issuesData.restaurant_id.logo_url
                  }
                />
              </SRLWrapper>
            </SimpleReactLightbox>
            <h5 className="f16-500 mt-2 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.restaurant_name}
            </h5>
          </div>
          <div className="col-4">
            <h5 className="f14-500 mb-2">Address</h5>
            <h5 className="f12-400 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.restaurant_address}
            </h5>
          </div>
          <div className="col-4">
            <h5 className="f14-500 mb-2">Restaurant Number</h5>
            {data &&
              data.map((number, index) => {
                return (
                  <React.Fragment key={index}>
                    <h5 className="f12-400 mb-2">
                      {number.country_code + "-" + number.mobile_no}
                    </h5>
                  </React.Fragment>
                );
              })}
            <h5 className="f14-500 mb-2 mt-3">City</h5>
            <h5 className="f12-400 mb-2">
              {props.issuesData &&
                props.issuesData.restaurant_id &&
                props.issuesData.restaurant_id.city}
            </h5>
          </div>
        </div>
      </div>
      {modalStatus && <>
        <StatusModal
          modalStatus={modalStatus}
          onCloseModal={onCloseModal}
          statusTypes={statusTypes}
          onChangeTempStatus={onChangeTempStatus}
          currentStatus={currentStatus}
          onSubmitHandler={onSubmit}
        />
      </>}
    </React.Fragment>
  );
};
